import $ from 'jquery';

export default class Accordion {
  constructor(instance) {
    this.$el = $(instance.el);
    $('[data-accordion-trigger]', this.$el).on('click.accordion', event => this._toggle(event));

    this.accordionContent = '[data-accordion-content]';
    this.accordionTrigger = '[data-accordion-trigger]';
    this.activeAccordion = 'accordion-active';
  }

  _toggle(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const trigger = $target.attr('data-accordion-trigger');
    const $content = $(`[data-accordion-content=${trigger}]`);

    if ($target.hasClass(this.activeAccordion)) {
      this._close($target, $content);
    } else {
      this._closeAll();
      this._open($target, $content);
    }
  }

  _closeAll() {
    $(this.accordionTrigger).each((index, accordion) => {
      const $target = $(accordion);

      if ($target.hasClass(this.activeAccordion)) {
        $target.trigger('click');
      }
    });
  }

  _open($target, $content) {
    $content.slideDown({
      duration: 400,
      start: () => $target.addClass(this.activeAccordion),
    });
  }

  _close($target, $content) {
    $content.slideUp({
      duration: 400,
      start: () => $target.removeClass(this.activeAccordion),
    });
  }

  onSectionBlockSelect(block) {
    const $container = $(block.el);
    const $target = $container.find(this.accordionTrigger);

    if (!$target.hasClass(this.activeAccordion)) {
      $target.trigger('click');
    }
  }

  unload() {
    $('[data-accordion-trigger]', this.$el).off('.accordion');
  }
}
